import { BaSeIcon } from "@base/react";
import { useEffect, useState } from "react";
import "./index.scss";

const ModalDefault = ({
                        show,
                        title,
                        children,
                        callBackClose,
                        square = false,
                        classCustom = "",
                        disableCloseBackdrop = false
                      }) => {
  const [showModal, setShowModal] = useState(show);
  const closeModal = () => {
    setShowModal(false);
    if (callBackClose) callBackClose();
  };

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal]);

  return (
    showModal && (
      <div className={"modal-default "+classCustom}>
        <div onClick={() => !disableCloseBackdrop ? closeModal() : false} className="close-page"></div>
        <div className={`wrapper-modal ${square ? "square" : ""}`}>
          <button className="btn-close" onClick={() => closeModal()}>
            <BaSeIcon
              color="#005EB8"
              description="Close"
              name="close"
              size={22}
            />
          </button>
          <div>
            {title && (
              <div className="modal-header">
                <h3 className={`title ${square ? "square-title" : ""} `}>
                  {title}
                </h3>
              </div>
            )}
            <div className="modal-body">
              {children}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalDefault;
